import Image from 'next/image';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonPolicyCompareBasicInfoView = function PriceComparisonPolicyCompareBasicInfoView(props) {
  var className = props.className,
      info = props.info;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-row space-x-1', className),
    children: [/*#__PURE__*/_jsx(Image, {
      className: "h-[30px] w-[30px]",
      src: "https://storage.googleapis.com/jove-public-images/quote/switch-to-jove-jiangbei-1.png",
      alt: "first",
      width: 30,
      height: 30
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "h6",
      className: "w-0 flex-1 text-[20px] font-black text-[#202020]",
      children: ["Switch to jove to save you ", /*#__PURE__*/_jsx("span", {
        className: "text-[#1CB258]",
        children: info === null || info === void 0 ? void 0 : info.annualSavingText
      })]
    })]
  });
};

export default PriceComparisonPolicyCompareBasicInfoView;